import getStore from '../store/store';

export default function getBackgroundImage(): string | undefined {
    return getStore().image;
}
